import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "../../api/axios";

const EmailConfirmPage = () => {
  const { uid, token } = useParams();
  const navigate = useNavigate();
  const [submitting, setSubmitting] = useState(false);
  const [resending, setResending] = useState(false);
  const [canResend, setCanResend] = useState(false);

  const handleConfirm = async () => {
    if (submitting) return;
    setSubmitting(true);
    try {
      const confirmRes = await api.post(`/accounts/confirm-email/${uid}/${token}/`);
      let isLoggedIn = false;
      try {
        const resAuth = await api.get("/accounts/auth_status/");
        isLoggedIn = !!resAuth.data?.isAuthenticated;
      } catch (_) {
        isLoggedIn = false;
      }
      navigate(isLoggedIn ? "/vault/main" : "/auth", { replace: true });
      setTimeout(() => {
        window.dispatchEvent(
          new CustomEvent("global-info", {
            detail: { message: confirmRes.data?.message || "Your email has been confirmed!" },
          })
        );
      }, 50);
    } catch (err) {
      const errorMessage =
        err.response?.data?.error ||
        err.response?.data?.detail ||
        "Email confirmation failed";
      const statusCode = err.response?.status;
      if (statusCode === 400) {
        setCanResend(true);
      }
      window.dispatchEvent(
        new CustomEvent("global-error", {
          detail: {
            message: errorMessage,
            status: statusCode,
          },
        })
      );
    } finally {
      setSubmitting(false);
    }
  };

  const handleResend = async () => {
    if (resending) return;
    setResending(true);
    try {
      const resendRes = await api.post("/accounts/confirm-email/resend/", { uid });
      window.dispatchEvent(
        new CustomEvent("global-info", {
          detail: {
            message:
              resendRes.data?.message ||
              "A new confirmation email has been sent.",
          },
        })
      );
      navigate("/auth", { replace: true });
    } catch (err) {
      window.dispatchEvent(
        new CustomEvent("global-error", {
          detail: {
            message:
              err.response?.data?.error ||
              err.response?.data?.detail ||
              "Failed to resend confirmation email",
            status: err.response?.status,
          },
        })
      );
    } finally {
      setResending(false);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "24px",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: "420px",
          border: "1px solid rgba(255,255,255,0.2)",
          borderRadius: "16px",
          padding: "24px",
          textAlign: "center",
          background: "rgba(8,15,31,0.72)",
          color: "#fff",
        }}
      >
        <h1 style={{ margin: "0 0 12px 0", fontSize: "22px" }}>Confirm Email</h1>
        <p style={{ margin: "0 0 20px 0", opacity: 0.86 }}>
          Continue to confirm your email and sign in.
        </p>
        <button
          onClick={handleConfirm}
          disabled={submitting}
          style={{
            width: "100%",
            border: 0,
            borderRadius: "12px",
            padding: "12px 16px",
            fontWeight: 700,
            background: submitting ? "#7a7a7a" : "#38bdf8",
            color: "#041020",
            cursor: submitting ? "not-allowed" : "pointer",
          }}
        >
          {submitting ? "Processing..." : "Continue"}
        </button>
        {canResend ? (
          <button
            onClick={handleResend}
            disabled={resending}
            style={{
              width: "100%",
              border: "1px solid rgba(255,255,255,0.3)",
              borderRadius: "12px",
              padding: "12px 16px",
              fontWeight: 700,
              background: "transparent",
              color: "#fff",
              cursor: resending ? "not-allowed" : "pointer",
              marginTop: "12px",
            }}
          >
            {resending ? "Sending..." : "Resend confirmation email"}
          </button>
        ) : null}
      </div>
    </div>
  );
};

export default EmailConfirmPage;
